import axios from 'axios';

interface Response<T> {
  data: T;
}
interface RequestOptions<T> {
  method: 'get' | 'post' | 'put' | 'delete';
  endpoint: string;
  data?: any;
  token?: string;
  responseType?: 'json' | 'blob' | 'text';
}

const api = axios.create({
  // baseURL: 'http://localhost:1337/api',
  baseURL: 'https://admin.tourin.tur.br/api',
  // baseURL: 'https://admin-homolog.tourin.tur.br/api',
});

// const api = axios.create({
//   baseURL: 'https://admin.tourin.tur.br/api',
// });

function request<T>(options: RequestOptions<T>) {
  return new Promise<Response<T>>(async (resolve, reject) => {
    try {
      const config: Record<string, any> = {
        method: options.method,
        url: options.endpoint,
      };
      if (options.data !== undefined) {
        config.data = options.data;
      }
      if (options.responseType) {
        config.responseType = options.responseType;
      }
      if (options.token) {
        config.headers = {
          Authorization: `Bearer ${options.token}`,
        };
      }
      const response = await api.request<Response<T>>(config);
      resolve(response.data);
    } catch (error) {
      console.error(error);
      reject({ data: null });
    }
  });
}


export default request;
export const urlBase = 'https://admin.tourin.tur.br';

export function resolveMediaUrl(url?: string | null): string {
  if (!url) {
    return "";
  }

  if (/^https?:\/\//i.test(url)) {
    return url;
  }

  return `${urlBase}${url}`;
}
